/* eslint-disable */
import { Select } from 'antd';
import update from 'immutability-helper';
import React, { useEffect, useReducer, useState } from 'react';

const { Option } = Select;

const reducer = (state, action) => {
  if (action.type === 'TOGGLE_OPT') {
    if (action.option in state && state[action.option] === action.value) {
      // deselect item if it is clicked again
      const { [action.option]: _, ...newState } = state;
      return newState;
    }

    return { ...state, [action.option]: action.value };
  }
  if (action.type === 'UPDATE_VARIANTS') {
    return update(state, {
      $apply: (items) => {
        // const { availableVariants } = action;
        // availableVariants.map(({ option: { _id }, value: { _id: valId } }) => {
        //   if (_id in items && items[_id] !== valId) {
        //     delete items[_id];
        //   }
        // });
        // console.log('inside update after delete', items);
        return items;
      }
    });
    //  return state;
  }

  if (action.type === 'RESET_FILTERS') {
    return {};
  }
};

const ProductOptions = ({
  options,
  variants,
  setVariant,
  product,
  outOfStockVariant,
  setOutOfStockVariant,
  setIsOptionSelected
}) => {
  const [productOptions, setProductOptions] = useState([]);
  const [key, updateKey] = useState(0);
  const [selected, dispatch] = useReducer(reducer, {});
  const setVariants = (optId, valId) =>
    dispatch({ type: 'TOGGLE_OPT', option: optId, value: valId });

  // const updateSelectedVariants = (availableVariants) =>
  //   dispatch({ type: 'UPDATE_VARIANTS', availableVariants });

  const resetFilters = () => {
    updateKey(key + 1);
    dispatch({ type: 'RESET_FILTERS' });
    setVariant('');
  };

  useEffect(() => {
    // if selected is empty (first time or if item is cleared)
    // set proper options
    if (Object.keys(selected).length === 0) {
      setProductOptions(options);
      return;
    }

    // filter variants based on all the selected items
    const availableVariants = variants
      .filter(
        ({ options }) =>
          options.find(
            (item) =>
              item.option._id in selected && selected[item.option._id] === item.value._id
          ) !== undefined
      )
      .flatMap((varnts) => varnts.options);
    // set product options
    // eslint-disable-next-line no-shadow
    setProductOptions((productOptions) =>
      productOptions.map((productOption) => {
        return {
          ...productOption,
          values: productOption.values.map((val) => ({
            ...val,
            disabled: availableVariants.every(({ value: { _id } }) => val._id !== _id)
          }))
        };
      })
    );
    // updateSelectedVariants(availableVariants);

    // check if variant combination isoutOfstock
    let selectedVariant;
    const selectedPropertiesValues = Object.values(selected);

    // eslint-disable-next-line
    let isFound = selectedPropertiesValues.map((elem) => false);

    for (let i = 0; i < product.variants.length; i++) {
      if (typeof selectedVariant === 'object') break;
      for (let j = 0; j < selectedPropertiesValues.length; j++) {
        product.variants[i].options.forEach((opt) => {
          if (opt.value._id === selectedPropertiesValues[j]) {
            isFound[j] = true;
            const checker = (value) => value === true;
            if (isFound.every(checker) === true) {
              selectedVariant = product.variants[i];
            }
          }
        });
      }
      // eslint-disable-next-line
      isFound = selectedPropertiesValues.map((elem) => false);
    }

    console.log(selectedVariant, 'SelectedVariant');
    // console.log(selectedPropertiesValues.length)
    if (typeof selectedVariant === 'undefined') {
      setOutOfStockVariant(true);
    } else {
      setOutOfStockVariant(false);
    }

    if (selectedPropertiesValues.length > 0) {
      if (options.length === selectedPropertiesValues.length) {
        setIsOptionSelected(true);
      }
    }
  }, [selected, key]);

  useEffect(() => {
    setVariant(selected);
  }, [selected]);

  const displayColorsInSelect = (value) => {
    const colors = value.split('|');
    return colors.map((color, i) => {
      return (
        <div
          key={i.toString()}
          className="colors"
          style={{
            backgroundColor: color
          }}
        />
      );
    });
  };

  return (
    <div>
      {outOfStockVariant && <p style={{ color: '#f03912' }}>{t('outOfStock')}</p>}
      {productOptions.map((opt, i) => (
        <div className="mt-20" key={opt._id} id={`${productOptions}${i}`}>
          {/* <div className="select-label">{opt.display_name}</div>*/}
          <Select
            key={key}
            // allowClear
            className="bordered-select"
            defaultValue={<p className="text-18-normal">{opt.display_name}</p>}
            // value={opt._id in selected ? selected[opt._id] : opt.display_name}
            style={{ width: '100%' }}
            placeholder={opt.display_name}
            getPopupContainer={() => document.getElementById(`${productOptions}${i}`)}
            onChange={(valId) => setVariants(opt._id, valId)}
          >
            <Option key={opt.display_name} disabled>
              {opt.display_name}
            </Option>
            {opt.values.map((val) => (
              <Option key={val._id} disabled={val.disabled}>
                <div className="select-colors">
                  <div className="mr-10">{val.label}</div>{' '}
                  <div className="select-colors">
                    {opt.type === 'swatch' ? displayColorsInSelect(val.value) : null}
                  </div>
                </div>
              </Option>
            ))}
          </Select>
        </div>
      ))}
      <div className="text-right mt-10 clear-filters hover" onClick={resetFilters}>
        Καθαρισμός Επιλογών
      </div>
    </div>
  );
};

export default ProductOptions;
